import * as Sentry from "@sentry/react";
import { CaptureConsole as CaptureConsoleIntegration, Offline as OfflineIntegration } from "@sentry/integrations";
import Config from '../config/config';
import { ErrorCategories } from "../enums/error-categories.enum";
import {CustomError} from "../models/custom-error-builder"
import UtilService from "./util.service";

const Category = "Category"
const Platform = "Platform"
const AppName = "AppName"

const packageJson = require("../../package.json")

const win = window 

export class SentryService {
    static init() {
        if (Config.sentry.enabled) {
            const release = (packageJson && packageJson.config && packageJson.config.release) || ""
            win['sentryRelease'] = release
            Sentry.init({
                environment: Config.sentry.environment,
                debug: true,
                release: release,
                dsn: Config.sentry.dsn,
                integrations: [
                    new CaptureConsoleIntegration(
                        {
                            // array of methods that should be captured
                            // defaults to ['log', 'info', 'warn', 'error', 'debug', 'assert']
                            levels: ['error']
                        }
                    ),
                    new OfflineIntegration(
                        {
                            // limit how many events will be localled saved. Defaults to 30.
                            maxStoredEvents: 30
                        }
                    )
                ],

                // We recommend adjusting this value in production, or using tracesSampler
                // for finer control
                tracesSampleRate: 1.0,
                beforeSend: (event) => {
                    if (event) {
                        if (!event.tags) {
                            event.tags = { [Category]: ErrorCategories.UNCAUGHT_ERROR }
                        }
                        if (!event.tags[Category]) {
                            event.tags[Category] = ErrorCategories.UNCAUGHT_ERROR
                        }
                    }
                    event.tags[Platform] = UtilService.isMobileApp() ? (UtilService.isIOSWebview() ? "IOS" : "Android") : "Web"
                    event.tags[AppName] = UtilService.getAppName()
                    return event
                }
            });
        }
    }

    static captureException = ({ errorInfo, message, errorCategory, extraInfo }) => {
        if (Config.sentry.enabled) {
            let err = errorInfo
            if (errorInfo) {
                err = new CustomError(errorInfo, message)
            }
            const category = errorCategory || ErrorCategories.OTHER

            Sentry.withScope(scope => {
                scope.setTag(Category, `${category}`)
                if (extraInfo) {
                    scope.setExtras({ extraInfo })
                }
                Sentry.captureException(err)
            })
        }
    }

    static captureApiError = ({ errorInfo, url, method, options, body}) => {
        if (Config.sentry.enabled) {
            const errorCode = (errorInfo && errorInfo.response && errorInfo.response.status) ? errorInfo.response.status : ""
            const message = `${ErrorCategories.API_ERROR} - ${url} - ${errorCode}`
            SentryService.captureException({ errorInfo, message, errorCategory: ErrorCategories.API_ERROR, extraInfo: { url, method, options, body, errorInfo } })
        }
    }

}